import { Guid } from '@web/utils';
import { PaymentMethodCode } from '../../shared/enums/payment-method-code';
import { PaymentStatus } from '../../shared/enums/payment-status';

export class PublicOrderPayment {
  public constructor(
    private readonly data: {
      number: string;
      status: PaymentStatus;
      createdAt: Date;
      paymentMethodId: Guid;
      paymentMethodCode: PaymentMethodCode;
      paymentMethodName: string;
    },
  ) {}

  public get number(): string {
    return this.data.number;
  }

  public get status(): PaymentStatus {
    return this.data.status;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get paymentMethodId(): Guid {
    return this.data.paymentMethodId;
  }

  public get paymentMethodCode(): PaymentMethodCode {
    return this.data.paymentMethodCode;
  }

  public get paymentMethodName(): string {
    return this.data.paymentMethodName;
  }
}
